import { render, staticRenderFns } from "./OfertaUpSolicitudDefault.vue?vue&type=template&id=5cf202a4"
import script from "./OfertaUpSolicitudDefault.vue?vue&type=script&lang=js"
export * from "./OfertaUpSolicitudDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf202a4')) {
      api.createRecord('5cf202a4', component.options)
    } else {
      api.reload('5cf202a4', component.options)
    }
    module.hot.accept("./OfertaUpSolicitudDefault.vue?vue&type=template&id=5cf202a4", function () {
      api.rerender('5cf202a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Ofertas/CBA/OfertaUpSolicitudDefault.vue"
export default component.exports